<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {fetchPortalMap} from "@/api/system";

export default {
  name: 'App',

  data() {
    return {
      portalInfo: null
    }
  },

  watch: {
    "$route": function ({name, params, meta}) {
      if (name === 'detail' && params.item && params.item.title && params.item.title.length > 1) {
        let title = params.item.title;
        if (params.item.subTitle && params.item.subTitle.length > 1) {
          title = title + '｜' + params.item.subTitle
        }
        this.changeTitle(title);
      } else {
        this.changeTitle(meta.title);
      }
    }
  },

  methods: {
    changeFavicon() {
      if(this.portalInfo && this.portalInfo.favicon && this.portalInfo.favicon.length > 1) {
        const link = document.querySelector("linl[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = this.portalInfo.favicon;
        document.getElementsByTagName('head')[0].appendChild(link);
      }
    },

    changeTitle(title) {
      if (title && title.length > 1) {
        document.title = title;
      } else if (this.portalInfo && this.portalInfo.title && this.portalInfo.title.length > 1) {
        document.title = this.portalInfo.title;
      }
    },

    getPortalDetail() {
      fetchPortalMap().then(response => {
        this.portalInfo = response.data;
        this.changeFavicon();
        this.changeTitle();
      })
    }
  },

  mounted() {
    this.getPortalDetail();
  }
}
</script>

<style>
#app {
  width: 100%;
  min-width: 960px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue